<template>
	<button class="btn btn-icon-text" :disabled="loading">
		<spinner v-if="loading" size="small" class="spinner"/>
		<svgicon v-else :name="icon" :fill="false"></svgicon>
		<span>
			<slot/>
		</span>
	</button>
</template>

<script>
export default {
	props: [
		'loading',
		'click',
		'icon'
	]
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/ButtonIconTextLoading.vue